import React from "react";
import "../../../pages/Snapshots/snapshots.css"
import NewSnapshot from "../NewSnapshot/NewSnapshot";

/*

  Searchbar that user can use to select a company
  < input = select, selectValue, comp, repos, seaarchTerm, setSearchTerm >

 */

function SearchBar({
  select,
  selectValue,
  comp,
  repos,
  searchTerm,
  setSearchTerm,
  repoSelected
}) {
  return (
    <div className="search-bar">
      {/* Display company select dropdown only if the user's position is 3 
      However, manager does not use HecoRep, only Analyst. This first dropbox should be removed in the future.
      */}
      {localStorage.getItem("position") === "3" ? (
        <div className="options-container">
          <select className="settings-select" onChange={select}>
            <option value="" defaultValue disabled hidden>
              Select company...
            </option>
            {comp.map((item) => {
              return <option key={item} value={item}>{item}</option>;
            })}
          </select>
        </div>
      ) : (
        ""
      )}
      {/* Repository select dropdown */}
      <div className="options-container">
        <select
          className="settings-select"
          onChange={selectValue}
          value={localStorage.getItem("repoName") || ""}
          style={repoSelected ? {color: "black"} : {color: "var(--disabledGrey)"}}
        >
          <option value="" disabled>
           Select repository...
          </option>
          {repos.map((item) => {
            return <option key={item} value={item}>
              {item}
              </option>;
          })}
        </select>
      </div>
      {/* Snapshot search bar */}
      <div className="search-container">
      <input
        type="text"
        placeholder="Search for a snapshot..."
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
      />
      </div>
      <NewSnapshot/>
    </div>
  );
}

export default SearchBar;
